import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { GETInventoryService } from '../../../services/inventory.service';
import { ImplementDetailsService } from '../../../implement-details/implement-details.service';
import { ImplementCycleDetails, ImplementRebuildCompleteVM } from '../../../add-observation-point/add-observation-point-modal';
import { ErrorCode, ErrorMessages } from '../../../entities/global/error-codes';
import { NotificationsService } from 'angular2-notifications';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../../../adapters/ordinal-date-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-implement-rebuild-complete-dialog',
  templateUrl: './implement-rebuild-complete-dialog.component.html',
  styleUrls: ['./implement-rebuild-complete-dialog.component.css'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class ImplementRebuildCompleteDialogComponent implements OnInit {

  implementId:number
  implementName:string
  customerID:number
  jobsiteId:number;
  jobsiteName:string;
  eventDate: Date = new Date();
  startDate:Date;
  CycleDetails:ImplementCycleDetails;
  cycleNo:number=0;
  hours:number;
  bcm:number;
  tons:number;
  comment:string;
  savingChanges:boolean=false;
  constructor(private dialogRef: MatDialogRef<ImplementRebuildCompleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _inventoryService: GETInventoryService,
    public addRepairerWorkshopModal: MatDialog,
    public _implementService: ImplementDetailsService,
     public toastr: NotificationsService, vcr: ViewContainerRef) {
      
    }
  ngOnInit() {
    console.log(this.data,"DATA")
    if(this.data != null){
      this.implementId=this.data.implementId;
      this.customerID=this.data.customerId;
      this.implementName =this.data.implementName;
      this.jobsiteId=this.data.jobsiteId;
      this.jobsiteName=this.data.jobsiteName;
    }
    if(this.implementId>0){
      this.getCycleDetails();
    }
  }

 // bcm_previous:number
  //Load Current Cycle Details
  getCycleDetails(){
    this._implementService.GetCurrentCycleDetails(this.implementId).subscribe(response=>{
      console.log(response)
      this.CycleDetails=response;
      this.startDate = this.CycleDetails.EndDate;
      this.cycleNo=this.CycleDetails.CycleNo;
      //this.eventDate=this.startDate
      this.tons=this.CycleDetails.Tons;
      this.bcm=this.CycleDetails.BCM;
      this.hours=this.CycleDetails.Hours;
    })
  }

  saveChanges(){
    if (this.savingChanges) {
      return;
  }

  let validation = this.validateData();
  this.savingChanges = true;
  if (validation == ErrorCode.VALIDATION_PASSED) {
    var params: ImplementRebuildCompleteVM = new ImplementRebuildCompleteVM();
        params.ImplementId = this.implementId;
        params.StartDate = this.eventDate;
        params.comment=this.comment;
        params.Hours=this.hours;
        params.BCM=this.bcm;
        params.Tons=this.tons;
        params.jobsiteID=this.jobsiteId;
        params.CycleNo=this.cycleNo+1;
        console.log("params",params)
    this._implementService.SaveRebuildComplete(params).subscribe(response=>{
      console.log("response", response)
      if(response){
        this.dialogRef.close();
      }
    })
  }else{
    this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
    this.savingChanges = false;
  }
  }

  validateData(): number {
    var returnCode = ErrorCode.ERROR_MISSING_FIELDS;
        if (this.implementId
            && this.hours >=0
            && this.bcm >=0
            && this.tons >=0
            && this.startDate
            && this.comment) {
              returnCode = ErrorCode.VALIDATION_PASSED;
        }
    return returnCode;
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
